'use strict';

var getGlobal = require('globalthis/polyfill');

// https://262.ecma-international.org/6.0/#sec-getglobalobject

module.exports = function GetGlobalObject() {
	return getGlobal();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2016/GetGlobalObject.js
// module id = 677
// module chunks = 0